import { Check } from "lucide-react";
import { fmtDate } from "@/lib/api";

/** Horizontal progress: Filed → Fee paid → Arbitrator assigned → Hearing scheduled → Award passed. */
export const CaseTimeline = ({ steps }) => {
  if (!steps?.length) return null;
  const doneCount = steps.filter((s) => s.done).length;
  return (
    <section className="border border-border bg-card p-5" data-testid="case-timeline">
      <p className="label-caps">Progress · {doneCount} of {steps.length} stages</p>
      <ol className="mt-4 grid grid-cols-5 gap-2">
        {steps.map((s, i) => {
          const current = !s.done && steps.slice(0, i).every((x) => x.done);
          return (
            <li key={s.key} className="relative" data-testid={`timeline-${s.key}`} data-done={s.done}>
              {i < steps.length - 1 && (
                <span className={`absolute left-1/2 top-3 h-0.5 w-full ${steps[i + 1].done || (s.done && current === false) ? "bg-blue-900" : "bg-border"}`} />
              )}
              <div className="relative flex flex-col items-center text-center">
                <span className={`z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 text-[10px] font-mono transition-colors duration-300 ${
                  s.done ? "bg-blue-900 border-blue-900 text-white" : current ? "border-blue-900 bg-card text-blue-900 animate-pulse" : "border-border bg-card text-muted-foreground"}`}>
                  {s.done ? <Check className="h-3.5 w-3.5" /> : i + 1}
                </span>
                <p className={`mt-2 text-[11px] uppercase tracking-wider leading-tight ${s.done ? "font-medium" : "text-muted-foreground"}`}>{s.label}</p>
                <p className="text-[10px] text-muted-foreground mt-0.5">{s.done && s.at ? fmtDate(s.at) : s.note || ""}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
